import { render, staticRenderFns } from "./NlWordpress.vue?vue&type=template&id=d308afb6&"
import script from "./NlWordpress.vue?vue&type=script&lang=js&"
export * from "./NlWordpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports